import * as s from "styles/ModalCommonStyled";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import BigButton from "components/atoms/buttons/BigButton";
import { ModalInput } from "components/atoms/input/modal/ModalInput";
import Input from "components/atoms/input/Input";
import { ValidateWord } from "components/atoms/text/Text";
import { ValidateMsg } from "api/interfaces/commonInterface.interface";
import { UnprivilegedEditor } from "react-quill";
import { DeltaStatic, Sources } from "quill";
import ToggleComponent from "components/atoms/toggle/Toggle";
import { ReleaseNoteCreateResult } from "api/interfaces/settingsInterface.interface";
import DeactivateButton from "components/blocks/modal/deactivate";
import Spinner from "components/atoms/loader/Spinner";
import EmailEditor from "components/atoms/input/editor/EmailEditor";
import InputDate from "components/atoms/calendar/InputDate";

interface Props {
  onModal: (type?: string) => void;
  onChange: (e: any) => void;
  form: ReleaseNoteCreateResult;
  onDelete?: (id: string) => void;
  validateMsg?: ValidateMsg;
  onSave: () => void;
  selectedRow?: ReleaseNoteCreateResult | undefined;
  isLoading: boolean;
}

export function AddModalPresenter(props: Props): JSX.Element {
  return (
    <BigPopupTemplate
      title={props.selectedRow ? "Edit Release Note" : "Add Release Note"}
      onModal={props.onModal}
    >
      <s.AddWrapper>
        <s.Row>
          <ModalInput
            label="Version"
            essential
            flex={1}
            validatedWord={props.validateMsg?.version}
            isValidated={!!props.validateMsg?.version}
          >
            <Input
              placeholder="Enter a version number"
              name="version"
              onChange={props.onChange}
              value={props.form.version}
              autoFocus={true}
              onKeyDown={(e) => {
                if (e.ctrlKey || e.metaKey || e.altKey) return;
                if (e.key.length !== 1) return;
                if (!/^[\d.-]$/.test(e.key)) {
                  e.preventDefault();
                }
              }}
              maxLength={40}
              data-testid="manager-release-notes-add-version-change"
            />
          </ModalInput>
          <ModalInput label="Release Date" essential flex={1}>
            <InputDate
              value={props.form.releasedAt}
              onChange={(date) =>
                props.onChange({ target: { name: "releasedAt", value: date } })
              }
            />
          </ModalInput>
        </s.Row>
        <ModalInput
          label="Contents"
          essential
          validatedWord={props.validateMsg?.content}
          isValidated={!!props.validateMsg?.content}
        >
          <EmailEditor
            value={props.form.content}
            onChange={(
              value: string,
              delta: DeltaStatic,
              source: Sources,
              editor: UnprivilegedEditor
            ) => {
              props.onChange({ target: { name: "content", value } });
            }}
          />
        </ModalInput>

        <ModalInput label="Active" essential>
          <ToggleComponent
            isToggled={props.form.isActive}
            onChange={(e) =>
              props.onChange({ target: { name: "isActive", value: e } })
            }
            dataTestId="manager-release-notes-add-active-toggle"
          />
        </ModalInput>
        <s.ButtonWrapper>
          {props.selectedRow && props.onDelete && (
            <DeactivateButton
              title="Do you really want to delete this release note?"
              subTitle="It cannot be recovered."
              onDeactive={() => {
                if (props.selectedRow?.id && props.onDelete) {
                  props.onDelete(props.selectedRow.id);
                }
              }}
              data-testid="manager-release-notes-add-deactivate-button"
            />
          )}

          <BigButton
            label="Save"
            onClickBtn={props.onSave}
            data-testid="manager-release-notes-add-button-save"
          />
        </s.ButtonWrapper>
      </s.AddWrapper>
      {props.isLoading && <Spinner />}
    </BigPopupTemplate>
  );
}
